import { Product } from 'types/order.type';

export const getProductName = (product: Product): string =>
  `${product.name} ${product.category}`.replace('Task Table', 'Task');
